import { useEffect, useState } from "react";
import "./screener.css";
import useScreenerList from "../../utils/CustomHooks/useScreenerList";
import PaginationComponent from "../../components/PaginationComponent";
import ScreenerData from "./Components/ScreenerData";
import ScreenerModal from "./modal/ScreenerModal";
import withRoleBased from "../../utils/Functions/withRoleBased";
import { sortArray } from "../../utils/Functions/filter";

function Index({ access = {} }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const [count, setCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const { screenerList, loading, getScreenerList } = useScreenerList();
  const { canCreate } = access;
  const pageCount = Math.ceil(screenerList.length / pageSize);
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);
  useEffect(() => {
    let req = {};
    if (search) req.screener_name = search;
    getScreenerList(req);
  }, [count]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
    // console.log(`Viewing Page ${index + 1} Data`);
  };

  const onSearch = () => {
    setCount((x) => x + 1);
    setCurrentPage(0)
    setIsSearch(search ? true : false);
  };
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 mb-3">
            <h5 className="page-title"> Screener</h5>
          </div>
          <div className="col-md-6  mb-3 d-flex justify-content-end">
            {canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Create Screener
              </button>
            )}
          </div>
          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table domain-table table-borderless">
                <thead>
                  <tr className="">
                    {access.isAdmin && <td className=""></td>}
                    <td className="">Name</td>
                    <td className="">Type </td>
                    <td className="">Sub Domain</td>
                    <td className="">Status</td>
                    <td className="">Action</td>
                  </tr>
                </thead>
                <tbody>
                  {!loading && screenerList && screenerList.length > 0 ? (
                    sortArray(screenerList)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((item, i) => (
                        <ScreenerData
                          item={item}
                          i={i}
                          key={i}
                          refresh={() => {
                            setCount((x) => x + 1);
                          }}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="font-weight-bold">
                          {loading ? "Loading..." : "Oops! No Data Found"}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {screenerList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
        <ScreenerModal
          isOpen={isOpen}
          setOpen={setIsOpen}
          refresh={() => {
            setCount((x) => x + 1);
          }}
          isEditable={access.canEdit}
        />
      </div>
    </main>
  );
}

export default withRoleBased(Index, "screener");
